module.exports = __webpack_public_path__ + "img/5.bac67191.jpg";